module.exports = {"audiences":["newAndNeededConfirmationAndNoTeams"],"autoTrack":true,"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-04-10"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/confirmDuringSignup.json
// module id = XK9X
// module chunks = 2